import { TableCell, TableHead, TableRow, TableSortLabel } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

import SortAZ from "@/svgs/sort-alpha-down.svg";
import SortZA from "@/svgs/sort-alpha-up.svg";
import Sort91 from "@/svgs/sort-numeric-down.svg";
import Sort19 from "@/svgs/sort-numeric-up.svg";
import { canViewAllAffiliates } from "@/utils/permissionsHandler";

const headCells = [
  {
    id: "processDate",
    numeric: true,
    disablePadding: true,
    label: "Processed Date",
    align: "left",
  },
  {
    id: "fileName",
    numeric: false,
    disablePadding: true,
    label: "File Name",
    align: "left",
  },
  {
    id: "local_name",
    numeric: false,
    disablePadding: true,
    label: "Local",
    align: "left",
  },
  {
    id: "num_rows",
    numeric: true,
    disablePadding: true,
    label: "Record Count",
    align: "right",
  },
  {
    id: "confirmed",
    numeric: false,
    disablePadding: true,
    label: "Validation",
    align: "center",
  },
  {
    id: "catalist",
    numeric: false,
    disablePadding: true,
    label: "Catalist",
    align: "center",
  },
  {
    id: "VAN",
    numeric: false,
    disablePadding: true,
    label: "VAN",
    align: "center",
  },
  {
    id: "IEB",
    numeric: false,
    disablePadding: true,
    label: "IEB",
    align: "center",
  },
  {
    id: "action",
    numeric: false,
    disablePadding: true,
    label: "Actions",
    align: "center",
  },
];

function SubmittedFilesTableHeader({ order, orderBy, onRequestSort, user }) {
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead id="submitted-files-table-header">
      <TableRow>
        {headCells.map((headCell, index) => {
          if (
            (headCell.label === "Local" || headCell.label === "IEB") &&
            !canViewAllAffiliates(user)
          ) {
            return <React.Fragment key={headCell.id}></React.Fragment>;
          }
          return (
            <TableCell
              key={headCell.id}
              align={headCell.align}
              sortDirection={orderBy === headCell.id ? order : false}
              className="submitted-files-table-header-cell"
            >
              {index < 4 ? (
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : "asc"}
                  onClick={createSortHandler(headCell.id)}
                  className="dashboardstyle-tableHead"
                >
                  <span>{headCell.label}</span>
                  <img
                    src={
                      order === "asc"
                        ? headCell.numeric
                          ? Sort19
                          : SortAZ
                        : headCell.numeric
                          ? Sort91
                          : SortZA
                    }
                    className={`dashboard-table-svg ${
                      orderBy !== headCell.id ? "dashboard-svg-hide" : ""
                    }`}
                    alt="Sort dashboard"
                  />
                </TableSortLabel>
              ) : (
                <span className="dashboardstyle-tableHead">
                  {headCell.label}
                </span>
              )}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}

SubmittedFilesTableHeader.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};

export default SubmittedFilesTableHeader;
